export enum Permission {
  CanChatWithAnyManagersInTheAccountEvenIfHotelDeptFiltered = 'Can_Chat_with_any_Managers_in_the_Account_even_if_Hotel_Dept_Filtered',
  CanEditApproveForecasts = 'Can_Edit_Approve_Forecasts',
  CanManageOwnEmailAlerts = 'Can_Manage_Own_Email_Alerts',
  CanEditHotelSettings = 'Can_Edit_Hotel_Settings',
  CanManageOwnUserProfile = 'Can_Manage_Own_User_Profile',
  CanAccessAPI = 'Can_Access_API',
  CanAccessHousekeepingBoardBuilder = 'Can_Access_Housekeeping_Board_Builder',
  CanDeleteAnyNewsFeed = 'Can_Delete_Any_Newsfeed',
  CanAccessGameDay = 'Can_Access_Gameday',
  CanAccessEmployeeDocuments = 'Can_Access_Employee_Documents',
  CanExportImportData = 'Can_Export_Import_Data',
  CanAccessHisHerOwnMyTraining = 'Can_Access_His_Her_Own_My_Training',
  CanAccessAbsenceMonitor = 'Can_Access_Absence_Monitor',
  CanAccessNightAuditEntryAndAddNewData = 'Can_Access_Night_Audit_Entry_And_Add_New_Data',
  CanAccessWellnessChecksAndReporting = 'Can_Access_Wellness_Checks_And_Reporting',
  CanAddEditEmployees = 'Can_Add_Edit_Employees',
  TNATimeCardsAndReportsComponent = 'TNA_TimeCardsAndReportsComponent',
  CanApproveExtraPlanHours = 'Can_Approve_Extra_Plan_Hours',
  TNARunPayrollReportComponent = 'TNA_RunPayrollReportComponent',
  CanAccessHotelRevenueAnalyzer = 'Can_Access_Hotel_Revenue_Analyzer',
  CanRequestExtraPlanHoursAndViewRequests = 'Can_Request_Extra_Plan_Hours_And_View_Requests',
  CanAccessTurnoverAnalytics = 'Can_Access_Turnover_Analytics',
  CanSeeFAndBProfitabilityMetrics = 'Can_See_F_And_B_Profitability_Metrics',
  CanAccessSettingsViewOnly = 'Can_Access_Settings_View_Only',
  TNAViewDownloadTimeclockPositionCodesComponent = 'TNA_ViewDownloadTimeclockPositionCodesComponent',
  CanCreateAnnouncement = 'Can_create_announcement',
  CanChatWithAnyEmployeesInTheirAssignedHotelsEvenIfDeptFiltered = 'Can_Chat_with_any_Employees_in_their_Assigned_Hotels_even_if_Dept_Filtered',
  CanAccessEmployeeManager = 'Can_Access_Employee_Manager',
  CanAccessPlanManagerAndViewLaborStandards = 'Can_Access_Plan_Manager_And_View_Labor_Standards',
  CanManageNightAuditorUserAndPassword = 'Can_Manage_Night_Auditor_User_And_Password',
  CanAccessLaborBenchMarker = 'Can_Access_Labor_Benchmarker',
  CanAccessRealtimeHotelLaborAnalyzer = 'Can_Access_Realtime_Hotel_Labor_Analyzer',
  CanCreateAndDeleteAnyNewsFeed = 'Can_Create_And_Delete_Any_Newsfeed',
  CanAccessDailyLaborCheckIn = 'Can_Access_Daily_Labor_Check_In',
  CanAccessSchedulerAndAddEditShifts = 'Can_Access_Scheduler_and_Add_Edit_Shifts',
  CanAccessBudgeterAndViewRevenueAndLaborBudgets = 'Can_Access_Budgeter_And_View_Revenue_And_Labor_Budgets',
  CanEditLaborStandards = 'Can_Edit_Labor_Standards',
  CanAccessMessaging = 'Can_Access_Messaging',
  CanAccessNewsfeed = 'Can_Access_Newsfeed',
  CanManageEmployeeUsersForMyHotelTeam = 'Can_Manage_Employee_Users_For_MyHotelTeam',
  CanAccessAssociateCheckIn = 'Can_Access_Associate_Check_In',
  CanViewCompensationData = 'Can_View_Compensation_Data',
  UserAccountAdmin = 'User_Account_Admin',
  IsInsiderContentEditor = 'Is_Insider_Content_Editor',
  IsInsider = 'Is_Insider',
  UserCanSeeWages = 'User_Can_See_Wages',
  TNAFilterByDepartments = 'TNA_Filter_By_Departments',
  IsInsiderFiltered = 'Is_Insider_Filtered',
  TNAFullAccess = 'TNA_Full_Access',
  HasDepartmentFilters = 'Has_Department_Filters',
  IsInsiderFull = 'Is_Insider_Full',
  TNAFilterBySupervisors = 'TNA_Filter_By_Supervisors',
  IsInsiderDeveloper = 'Is_Insider_Developer',
  HasMoreThanOneHotel = 'Has_More_Than_One_Hotel',
  UserHotelAdmin = 'User_Hotel_Admin',
  IsInsiderSuper = 'Is_Insider_Super',
  TNAOasisSync = 'TNA_Oasis_Sync',
  TNAHasChangesPending = 'TNA_Has_Changes_Pending',
  CanSendFileInAnnouncement = 'CAN_SEND_FILE_IN_ANNOUNCEMENT',
  CanAccessAndPickUpTasks = 'Can_Access_and_Pick_Up_Tasks',
  CanAssignAndDeleteTasksCreatedByOthers = 'Can_Assign_and_Delete_Tasks_Created_by_Others',
  CanCreateTasksAndAssignOrDeleteTasksCreatedByMyself = 'Can_Create_Tasks_and_Assign_or_Delete_Tasks_Created_by_Myself',
  CanAccessBoardBuilderV2AndRoomCleanTasks = 'Can_Access_Board_Builder_And_Room_Clean_Tasks',
  CanPublishSchedules = 'Can_Publish_Schedules',
}

export type GUID = string;

export type User = GUID[];

export type Component = Record<Permission, [GUID]>;
